/* eslint-disable react/no-deprecated */
import React, { useEffect, useState } from 'react';
import { Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form/immutable';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { Line } from '@vds/lines';

import { Body } from '../../../../common/Typography';
import SecurePin from '../SecurePin';
import ShippingInfoEdit from './ShippingInfoEdit';
import Button from '../../../../common/Button';
import { goToProcessStep } from '../../../../../redirection';
import { eventDispatcher } from '../../../../common/Tagging/index';
import {
  getFlowType,
  getSession,
  setSession,
  getAPPID,
  isMobile,
  renderElement,
  isDesktop,
  isLoggedIn as loggedIn,
  is5G,
  isTablet,
  isDesktopResolution,
  isMobileResolution,
  isShippingTabEnabled,
  isWHWP2,
  isExpressCheckout,
} from '../../../../common/Helpers/index';
import ContactInfoForm from './ContactInfoForm';
import { store } from '../../../../../configureStore';
import { CTAProps, nonDesktopQuery, nonMobileQuery, StyledWrapper } from '../shippingStyles';
import RadioButtonGroup from '../../../../common/RadioButton';
import {
  NEW_SHIPPING_ADDRESS,
  SAME_5G_BILLING_ADDRESS,
  SAME_5G_SERVICE_ADDRESS,
  SAME_LTE_BILLING_ADDRESS,
  SAME_LTE_SERVICE_ADDRESS,
  SAME_5G_LQ_ADDRESS,
  SAME_LTE_LQ_ADDRESS,
  MISSING_APARTMENT_UNIT_CODE,
  INVALID_APARTMENT_UNIT_CODE,
  MISSING_APARTMENT_UNIT_NAME,
} from '../../../../../pages/ShippingInfo/Constants';
import { mobileQuery } from '../../../../common/styles';
import { usePrevious } from '../../../../common/hooks';
import * as validation from '../../../../common/validation';

import { compareAddressInfo } from '../../../../common/addressUtils';
import { getFullAddress } from '../../../../common/ContactInfoUtils';

const AddressOptionCol = styled(Col)`
  .radioWrapper {
    span {
      font-weight: 400;
    }
    p {
      width: ${isMobile() ? '297.92px;' : '800px'};
    }
  }
  margin-top: ${isMobile() ? '24px' : '32px'};
`;
const AddressSubtext = styled(Body)`
  p {
    width: 297.92px;
  }
`;

const ShippingAdress = (props) => {
  const currentProps = props;
  const prevPropsobj = usePrevious(props);
  const [selectedSDDSlot, setSelectedSDDSlot] = useState({});
  const [shippingRadio, setShippingRadio] = useState('');
  const [disableButton, setDisableButton] = useState(false);
  const [showSecurePinModal, setShowSecurePinModal] = useState(false);
  const [tabValue, setTabValue] = useState(false);
  const [codeValid, setCodeValid] = useState(false);
  const [showISPUContactForm, setShowISPUContactForm] = useState(false);
  const [hideNewAddress, setHideNewAddress] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [routeToOverview, setRouteToOverview] = useState(false);
  const [isErrorOnUpdate, setIsErrorOnUpdate] = useState(false);
  const [invalidUnitAdress2, setInvalidUnitAdress2] = useState({});
  const [serviceAdressValidator, setServiceAdressValidator] = useState(false);
  let showLQAddress = false;
  const isExisingUser = loggedIn();
  const { smsEnabledDeviceCount, pinVerified } = props;

  useEffect(() => {
    if (smsEnabledDeviceCount === 0 && pinVerified === '') {
      setHideNewAddress(true);
    } else {
      setHideNewAddress(false);
    }
  }, [smsEnabledDeviceCount, pinVerified]);

  useEffect(() => {
    if (isExisingUser && props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay') && !addressChangeRequired) {
      if (
        // props.cart5GAddress?.zipCode !== props?.shippingAddAAL?.zipCode &&
        props.cart5GAddress?.addressLine1 !== props?.shippingAddAAL?.addressLine1
      ) {
        showLQAddress = true;
      }
    }
    if (props.cradleResponseDetails !== '' && props.cart5GAddress !== undefined && props?.shippingAddAAL !== undefined) {
      if (props.shippingAddressEdit) {
        setShippingRadio(NEW_SHIPPING_ADDRESS);
        props.setShippingAddressRadio(NEW_SHIPPING_ADDRESS);
      } else if (showLQAddress) {
        if (props.shippingAddressRadio === '' || props.shippingAddressRadio === getLQAddressText()) {
          if (
            props?.shippingAddAAL?.zipCode !== null &&
            props?.defaultShippingAddAAL?.zipCode !== null &&
            compareAddressInfo(props.shippingAddAAL, props.defaultShippingAddAAL)
          ) {
            setShippingRadio(SAME_5G_BILLING_ADDRESS);
          } else if (
            props?.cart5GAddress?.zipCode !== null &&
            props?.defaultShippingAddAAL?.zipCode !== null &&
            compareAddressInfo(props.cart5GAddress, props.defaultShippingAddAAL)
          ) {
            setShippingRadio(getLQAddressText());
          } else {
            setShippingRadio(getLQAddressText());
            props.setShippingAddressRadio(getLQAddressText());
          }
        } else if (props.shippingAddressRadio === getSameAddressPreferedText()) {
          setShippingRadio(getSameAddressPreferedText());
          props.setShippingAddressRadio(getSameAddressPreferedText());
        }
      } else if ((!showLQAddress && props.shippingAddressRadio === '') || props.shippingAddressRadio === getSameAddressPreferedText()) {
        setShippingRadio(getSameAddressPreferedText());
        props.setShippingAddressRadio(getSameAddressPreferedText());
      }
    }
  }, [props.cradleResponseDetails, props.cart5GAddress, props?.shippingAddAAL, props?.defaultShippingAddAAL]);

  useEffect(() => {
    setShowSecurePinModal(props.securePinData && props.shippingInfoState.showSecurePinModal);
    // if (props.defaultShippingAddAAL?.addressLine1) {
    //   props.fetchAutoFillAddress(props.defaultShippingAddAAL?.addressLine1);
    // }
    return () => {
      renderElement(null, 'ispuCTA');
      renderElement(null, 'shippingAddressCTA_2');
    };
  }, []);

  const isAddressChangeRequired = props.addressChangeRequired;
  const isAddressChangeRsnCodeValue = props.addressChangeRsnCode;
  let invalidUnitApartmentCase = false;
  if (
    isAddressChangeRequired &&
    window?.vzFlags?.isInvalidUnitNum &&
    isAddressChangeRsnCodeValue &&
    isAddressChangeRsnCodeValue !== '' &&
    (isAddressChangeRsnCodeValue === '360401' || isAddressChangeRsnCodeValue === '360402')
  ) {
    invalidUnitApartmentCase = true;
  }

  useEffect(() => {
    if (!props.showPickupInfoTab) {
      setShowISPUContactForm(false);
    }
  }, [props.showPickupInfoTab]);

  const addressChangeRequired = props?.addressChangeRequired;
  useEffect(() => {
    if (addressChangeRequired) {
      if (isExisingUser && props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay') && props?.cart5GAddress) {
        setDisableButton(false);
      } else {
        setDisableButton(true);
      }
    }
  }, [addressChangeRequired]);

  /** componentwillReceive props block */
  useEffect(() => {
    if (
      prevPropsobj?.selectedShippingOption &&
      prevPropsobj?.selectedShippingOption?.shippingOptionId !== currentProps?.selectedShippingOption?.shippingOptionId
    ) {
      if (!prevPropsobj?.addressChangeRequired) {
        if (currentProps.selectedShippingOption.shippingOptionId === 'SDD_SAMEDAY') {
          setShippingRadio(SAME_5G_BILLING_ADDRESS);

          setDisableButton(true);
        } else {
          setShippingRadio(getSameAddressPreferedText());
          setSelectedSDDSlot('');

          setDisableButton(false);
        }
      }
      if (!prevPropsobj?.addressChangeRequired) {
        if (showLQAddress) {
          if (props.shippingAddressRadio === '') {
            setShippingRadio(getLQAddressText());
            props.setShippingAddressRadio(getLQAddressText());
          } else {
            setShippingRadio(props.shippingAddressRadio);
            props.setShippingAddressRadio(props.shippingAddressRadio);
          }
        } else {
          setShippingRadio(getSameAddressPreferedText());
          props.setShippingAddressRadio(getSameAddressPreferedText());
        }
      }
    }
    if (prevPropsobj?.shippingInfoState && currentProps?.securePinData?.preAuthorized === 'true') {
      setCodeValid(true);
      setShowSecurePinModal(false);
      CloseModel();
    }
    if (currentProps.securePinDataDeviceSucess?.fetchSMSEnabledDevices && currentProps?.securePinData?.preAuthorized === 'false') {
      setShowSecurePinModal(true);
    }
    if (prevPropsobj?.shippingInfoState?.updateShippingAdressflag !== currentProps?.shippingInfoState?.updateShippingAdressflag) {
      if (getAPPID() !== 'AAL' && prevPropsobj?.isbillingInfoEdited) {
        redirection();
      }
      if (
        getAPPID() === 'AAL' &&
        props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay') &&
        (props.shippingAddressRadio === getLQAddressText() ||
          ((showLQAddress || addressChangeRequired) && props.shippingAddressRadio === getSameAddressPreferedText())) &&
        currentProps?.shippingInfoState?.updateShippingAdressflag
      ) {
        redirection();
        store.dispatch({ type: 'UPDATE_ADRESS_SUUCESS' });
      }
    }
  }, [currentProps, prevPropsobj]);

  const securePinTag = () => {
    const obj = {
      name: 'securePinModal',
      selector: 'securePinModalID',
    };
    eventDispatcher('openView', obj);
  };

  const redirection = () => {
    const { currentView, isCreditStatusAvailable, creditStatusLanded } = props;
    const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
    let updateView;
    if (getAPPID() === 'NSE') {
      updateView = currentView.CreditCheck;
    } else if ((getAPPID() !== 'NSE' && isCreditStatusAvailable) || (isCreditStatusAvailable && !creditStatusLanded)) {
      updateView = currentView.CreditStatus;
    } else if (props.totalDueToday === '0.0' && isNoSlotsAvailable !== 'Y') {
      updateView = currentView.OrderReview;
    } else if (isNoSlotsAvailable === 'Y') {
      if (props.totalDueToday > 0) {
        if (props.isPaymentNeed) {
          updateView = currentView.Payment;
        } else {
          updateView = currentView.OrderReview;
        }
      } else {
        updateView = currentView.OrderReview;
      }
      // setSession('isNoSlotsAvailable', 'N');
    } else if (props.totalDueToday > 0) {
      if (props.isPaymentNeed) {
        updateView = currentView.Payment;
      } else if (!props?.isPaymentNeed) {
        updateView = currentView.OrderReview;
      }
    } else {
      updateView = currentView?.OrderReview;
    }
    if (isExpressCheckout()) {
      updateView = currentView?.ExpressCheckout;
    }
    goToProcessStep(updateView, props.history);
  };

  const getSameAddressPreferedText = () => {
    // const isExisingUser = loggedIn();
    if (is5G) {
      return isExisingUser ? SAME_5G_BILLING_ADDRESS : SAME_5G_SERVICE_ADDRESS;
    }
    return isExisingUser ? SAME_LTE_BILLING_ADDRESS : SAME_LTE_SERVICE_ADDRESS;
  };

  const getLQAddressText = () => (is5G ? SAME_5G_LQ_ADDRESS : SAME_LTE_LQ_ADDRESS);

  const getShippingAddress = () => {
    const shipAdd = {
      adress1: props.shippingAddAAL?.addressLine1,
      adress2: props.shippingAddAAL?.addressLine2,
      city: props.shippingAddAAL?.city,
      zipCode: props.shippingAddAAL?.zipCode,
      state: props.shippingAddAAL?.state,
      firstName: props.shippingAddAAL?.firstName,
      lastName: props.shippingAddAAL?.lastName,
      emailId: props.shippingAddAAL?.emailId,
      phoneNumber: props.shippingAddAAL?.phoneNumber,
      isFwaServiceAddress: props.shippingAddressRadio === getSameAddressPreferedText(),
    };
    return shipAdd;
  };

  const getBillingAddress = () => {
    const billAdd = {
      adress1: props.cart5GAddress?.addressLine1,
      adress2: props.cart5GAddress?.addressLine2,
      city: props.cart5GAddress?.city,
      zipCode: props.cart5GAddress?.zipCode,
      state: props.cart5GAddress?.state,
      firstName: props.shippingAddAAL?.firstName,
      lastName: props.shippingAddAAL?.lastName,
      emailId: props.shippingAddAAL?.emailId,
      phoneNumber: props.shippingAddAAL?.phoneNumber,
      isFwaServiceAddress: true,
    };
    return billAdd;
  };

  const routingLogic = () => {
    const { currentView, isCreditStatusAvailable, creditStatusLanded } = props;
    const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
    let updateView;
    // let updateView = props.currentView.FiveG; NoSlotsAppointment
    if (getAPPID() === 'NSE') {
      updateView = currentView.CreditCheck;
    } else if ((getAPPID() !== 'NSE' && isCreditStatusAvailable) || (isCreditStatusAvailable && !creditStatusLanded)) {
      updateView = currentView.CreditStatus;
    } else if (props.totalDueToday === '0.0' && isNoSlotsAvailable !== 'Y') {
      updateView = currentView.OrderReview;
    } else if (isNoSlotsAvailable === 'Y') {
      if (props.totalDueToday > 0) {
        if (props.isPaymentNeed) {
          updateView = currentView.Payment;
        } else {
          updateView = currentView.OrderReview;
        }
      }
      // setSession('isNoSlotsAvailable', 'N');
    } else if (props.totalDueToday > 0) {
      if (props.isPaymentNeed) {
        updateView = currentView.Payment;
      } else {
        updateView = currentView.OrderReview;
      }
    } else {
      updateView = currentView.OrderReview;
    }
    if (isExpressCheckout()) {
      updateView = currentView?.ExpressCheckout;
    }
    return updateView;
  };

  const setAdressLine2 = (value) => {
    setInvalidUnitAdress2(value);
  };

  const locusIdNotFound = (locId) => {
    setIsErrorOnUpdate(locId);
  };

  const redirect = (e) => {
    e.preventDefault();
    const depletion = props?.depletionType?.indexOf('O') > -1 ? 'Prof' : 'Self';
    if (getSession('isNoSlotsAvailable') === 'Y' && depletion !== 'Prof') {
      setSession('isNoSlotsAvailable', 'N');
    }
    if (
      invalidUnitApartmentCase &&
      getAPPID() === 'AAL' &&
      invalidUnitAdress2?.addressLine2 !== '' &&
      invalidUnitAdress2?.addressLine2 !== undefined
    ) {
      const billingadd = getBillingAddress();
      const shippingadd = getShippingAddress();
      if (invalidUnitAdress2.addressLine1 === billingadd.adress1 && invalidUnitAdress2.zipCode === billingadd.zipCode) {
        billingadd.adress2 = invalidUnitAdress2.addressLine2;
        props.updateShippingAddress(billingadd);
      }
      if (invalidUnitAdress2.addressLine1 === shippingadd.adress1 && invalidUnitAdress2.zipCode === shippingadd.zipCode) {
        shippingadd.adress2 = invalidUnitAdress2.addressLine2;
        props.updateShippingAddress(shippingadd);
      }
      if (routeToOverview) {
        const updateViewData = routingLogic();
        goToProcessStep(updateViewData, props.history);
      }
    }

    // if (getAPPID() === 'AAL' && invalidUnitAdress2 && props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay')) {
    //   const billingadd = getBillingAddress();
    //   const shippingadd = getShippingAddress();
    //   if (invalidUnitAdress2.addressLine1 === billingadd.adress1 || invalidUnitAdress2.zipCode === billingadd.zipCode) {
    //     billingadd.adress2 = invalidUnitAdress2.addressLine2;
    //     props.updateShippingAddress(billingadd);
    //   }
    //   if (invalidUnitAdress2.addressLine1 === shippingadd.adress1 || invalidUnitAdress2.zipCode === shippingadd.zipCode) {
    //     shippingadd.adress2 = invalidUnitAdress2.addressLine2;
    //     props.updateShippingAddress(shippingadd);
    //   }
    // }

    // on SSD update contact Info have to make api call for same and If only Success take it next page

    // const { currentView, isCreditStatusAvailable, creditStatusLanded } = props;
    if (
      (getAPPID() !== 'AAL' && props.isbillingInfoEdited) ||
      (props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay') &&
        !props.getCheckOutDetailsState?.getCheckoutResponse?.data?.cart?.lineDetails?.lineInfo?.newLine1?.shipping?.storeInfo &&
        ((getAPPID() === 'AAL' && props.shippingAddressRadio === getLQAddressText()) ||
          (getAPPID() === 'AAL' && (showLQAddress || addressChangeRequired) && props.shippingAddressRadio === getSameAddressPreferedText())))
    ) {
      let data = getShippingAddress();
      if (
        getAPPID() === 'AAL' &&
        props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay') &&
        props.shippingAddressRadio === getLQAddressText()
      ) {
        data = getBillingAddress();
      }
      const defaultBillingAdd =
        (showLQAddress || addressChangeRequired) &&
        props?.defaultShippingAddAAL?.addressLine1 === data.adress1 &&
        props?.defaultShippingAddAAL?.zipCode === data.zipCode;
      // TODO: Need to check for homephoenAdded flag for getCheckout and add it here
      let homePhoneAdded = false;
      const homePhoneResponse = props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
      if (homePhoneResponse?.length > 0) {
        homePhoneAdded = true;
      }
      data.homePhoneAdded = homePhoneAdded;
      // calling shipping adress
      if (!defaultBillingAdd) {
        props.updateShippingAddress(data, homePhoneAdded);
      } else {
        const updateViewDataForRoute = routingLogic();
        goToProcessStep(updateViewDataForRoute, props.history);
      }
    } else {
      const updateViewData = routingLogic();
      goToProcessStep(updateViewData, props.history);
    }
  };

  const modalChanged = (state) => {
    if (!state) {
      setShippingRadio(getSameAddressPreferedText());
    }
  };

  const onClickEdit = () => {
    // const { fetchSMSEnabledDevices } = props;
    const isLoggedIn = getAPPID() === 'AAL';
    if (isLoggedIn === true) {
      // fetchSMSEnabledDevices();
      if (showSecurePinModal) {
        securePinTag();
      }
    } else {
      setShowSecurePinModal(false);
      setDisableButton(true);
    }
    store.dispatch({ type: 'CLEAR_MARKET_DETAILS' });
  };

  const CloseModel = () => {
    setShowSecurePinModal(false);
    setDisableButton(false);
  };

  const onChangeHandler = (e) => {
    setShippingRadio(e.target.value);
    props.setShippingAddressRadio(e.target.value);
    if (e.target.value === NEW_SHIPPING_ADDRESS) {
      if (window.vzFlags?.isOnlyTypeAhead === 'app') {
        props.apiConfigCall();
      }
      onClickEdit();
    } else if (e.target.value === SAME_5G_LQ_ADDRESS || e.target.value === SAME_LTE_LQ_ADDRESS) {
      setShowForm(true);
      setDisableButton(false);
      props.shippingAddressEdited(false);
    } else {
      setShowForm(false);
      setDisableButton(false);
      props.shippingAddressEdited(false);
    }
  };

  const toggleContactInfoSDD = () => {
    setSelectedSDDSlot({});
  };

  const cancelUpdated = () => {
    props.clearDevices();
    let disable = false;
    if (props?.addressChangeRequired) {
      disable = true;
    }
    setShippingRadio(getSameAddressPreferedText());

    setDisableButton(disable);
    setShowSecurePinModal(false);
  };

  const toggleContactInfoISPU = () => {
    setShowISPUContactForm(true);
  };

  // used to enable or disable functionality in shipping info edit form.
  const tabValueHandler = (value) => {
    setTabValue(value);
  };

  const displayNewSHPAddressForm = () => {
    if (getAPPID() === 'AAL') {
      if (shippingRadio === NEW_SHIPPING_ADDRESS && !showSecurePinModal && codeValid && !props.shippingAddressEdit) {
        props.shippingAddressEdited(true);
      }
      return shippingRadio === NEW_SHIPPING_ADDRESS && !showSecurePinModal && codeValid;
    }
    return shippingRadio === NEW_SHIPPING_ADDRESS && showSecurePinModal;
  };

  const isBTARedirection = () => {
    if (props.shippingInfoState && props.shippingInfoState.paymentSkipCall && props.totalDueToday > 0 && props.paymentInfoState) {
      if (props.isBTAAvailable && props.isBTAAvailable.length > 0) {
        store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: true });
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        store.dispatch({ type: 'CONFIRM_SUBMIT_CALL', value: true });
      } else if (props.otherPaymentOptions && props.otherPaymentOptions.length > 0) {
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        const updateView = props.currentView.Payment;
        goToProcessStep(updateView, props.history);
      }
    }
  };

  // routing logic when api is success
  useEffect(() => {
    if (
      !isEmpty(props?.shippingInfoState?.updateShippingAdressResponse) &&
      props?.shippingInfoState?.updateShippingAdressResponse?.errors === undefined
    ) {
      if (
        invalidUnitApartmentCase &&
        (MISSING_APARTMENT_UNIT_CODE !== props?.invalidAdressUnitCode || INVALID_APARTMENT_UNIT_CODE !== props?.invalidAdressUnitCode)
      ) {
        setRouteToOverview(true);
      }
    }
  }, [props?.shippingInfoState]);

  const { shippingInvalidError, apiFailureError } = props;
  if (props.shippingInfoDetails?.lines?.[0]?.shippingOptions && isEmpty(props.shippingInfoDetails?.lines?.[0]?.shippingOptions)) {
    setDisableButton(true);
  }
  if (shippingInvalidError || apiFailureError) {
    setDisableButton(true);
  }
  const flowType = getFlowType();
  const isLoggedIn = getAPPID() === 'AAL';

  /* reset radio selection to first radio option on tab switch */
  useEffect(() => {
    if (!props?.showPickupInfoTab && shippingOptions?.length > 0) {
      setShippingRadio(shippingOptions[0]);
    }
  }, [props?.showPickupInfoTab]);

  const { shippingAddress, notifyMessage, shippingInfoState: { selectedValue } = {} } = props;
  const sameAdress = getSameAddressPreferedText();
  let LQAddress = '';
  const shippingOptions = [];
  isBTARedirection();

  if (props.isBTAEligible && props.paymentInfoState && props.paymentInfoState.confirmSubmitCall) {
    const updateView = props.currentView.OrderReview;
    goToProcessStep(updateView, props.history);
    store.dispatch({ type: 'REDIRECT_DONE', value: true });
    store.dispatch({ type: 'CONFIRM_SUBMIT_CALL', value: false });
    store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: false });
  }
  if (validation?.isPoBoxAddress(props?.primaryUserInfo?.address?.addressLine1)) {
    if (isExisingUser && props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay')) {
      if (
        // props.shippingAddAAL?.zipCode !== props?.shippingAddAAL?.zipCode &&
        props.cart5GAddress?.addressLine1 !== props?.shippingAddAAL?.addressLine1
      ) {
        showLQAddress = true;
        LQAddress = flowType === 'LTE' ? SAME_LTE_LQ_ADDRESS : SAME_5G_LQ_ADDRESS;
      }
    }
    if (showLQAddress) {
      LQAddress = flowType === 'LTE' ? SAME_LTE_LQ_ADDRESS : SAME_5G_LQ_ADDRESS;
      if (LQAddress !== '') {
        if (hideNewAddress) {
          shippingOptions.push(LQAddress);
        } else {
          shippingOptions.push(LQAddress, NEW_SHIPPING_ADDRESS);
        }
      }
      // if (LQAddress !== '') shippingOptions.push(LQAddress, NEW_SHIPPING_ADDRESS);
    } else {
      shippingOptions.push(NEW_SHIPPING_ADDRESS);
    }
  } else if (isAddressChangeRequired && isExisingUser && isAddressChangeRsnCodeValue === '') {
    shippingOptions.push(getSameAddressPreferedText(), NEW_SHIPPING_ADDRESS);
  } else {
    if (isExisingUser && props.cradleResponseDetails?.includes('FWA_T_ServiceAddressDisplay')) {
      if (
        // props.cart5GAddress?.zipCode !== props?.shippingAddAAL?.zipCode &&
        props.cart5GAddress?.addressLine1 !== props?.shippingAddAAL?.addressLine1
      ) {
        showLQAddress = true;
        LQAddress = flowType === 'LTE' ? SAME_LTE_LQ_ADDRESS : SAME_5G_LQ_ADDRESS;
      }
    }
    if (LQAddress !== '') {
      if (hideNewAddress) {
        shippingOptions.push(LQAddress, getSameAddressPreferedText());
      } else {
        shippingOptions.push(LQAddress, getSameAddressPreferedText(), NEW_SHIPPING_ADDRESS);
      }
    } else {
      shippingOptions.push(getSameAddressPreferedText(), NEW_SHIPPING_ADDRESS);
    }
  }
  const serviceAddress = getFullAddress(props?.shippingAddAAL);

  const storeInfo = props.getCheckOutDetailsState?.getCheckoutResponse?.data?.cart?.lineDetails?.lineInfo?.newLine1?.shipping?.storeInfo;
  const ispuSelected = storeInfo && selectedValue === 'ISPU';
  const showPickupInfo = isShippingTabEnabled() ? props?.showPickupInfoTab && !showISPUContactForm : ispuSelected && !showISPUContactForm;
  const showISPUCTA = isShippingTabEnabled() ? props?.showPickupInfoTab && !showISPUContactForm : ispuSelected && !showISPUContactForm && storeInfo;
  const showShippingAddressCTA = isShippingTabEnabled()
    ? !props.showPickupInfoTab && shippingRadio !== NEW_SHIPPING_ADDRESS
    : shippingRadio !== NEW_SHIPPING_ADDRESS && Object.keys(selectedSDDSlot).length === 0 && (!shippingAddress?.length || !storeInfo);

  const ispuCTA = (
    <>
      {showISPUCTA && (
        <StyledWrapper styles={`${isTablet() ? 'margin-top: 20px;' : ''} ${mobileQuery('margin-top: 20px;')}`}>
          <Button className="ispuCTA" primary onClick={(e) => redirect(e)} {...CTAProps}>
            Continue
          </Button>
        </StyledWrapper>
      )}
    </>
  );
  const shippingAddressCTA = (
    <>
      {showShippingAddressCTA && (
        <StyledWrapper styles={`margin-top: 20px; ${nonDesktopQuery('margin-top: 63px;')}`}>
          <Button
            className={`shippingAddressCTA ${storeInfo ? 'hideContentShipping' : ''}`}
            primary
            onClick={(e) => redirect(e)}
            disabled={storeInfo ? false : disableButton}
            data-track="true"
            width={(isTablet() && !isDesktopResolution()) || isMobileResolution() ? '383px' : '100%'}
          >
            {isWHWP2() ? 'Review order' : 'Continue'}
          </Button>
        </StyledWrapper>
      )}
    </>
  );

  const shippingUnitForm = (formData, radioAddress = {}) => (
    <ShippingInfoEdit
      {...props}
      tabValue={tabValue}
      tabValueHandler={(value) => {
        tabValueHandler(value);
      }}
      updateShippingAdressflag={props.shippingInfoState.updateShippingAdressflag}
      shippingDetails={props.shippingAddAAL}
      notifyMessage={notifyMessage}
      fetchAutoFillAddress={props.fetchAutoFillAddress}
      addressList={props.addressList}
      shippingAddressErrorMessage={props.shippingAddressErrorMessage}
      isEmptyAddress={props.isEmptyAddress}
      lvShippingAddressTitle={props?.lvShippingAddressTitle}
      lvShippingAddressSubtitle={props?.lvShippingAddressSubtitle}
      redirection={redirection}
      isBTARedirection={isBTARedirection}
      radioBtnSelected={formData}
      radioAddress={radioAddress}
      setAdressLine2={setAdressLine2}
      invalidUnitApartmentCase={invalidUnitApartmentCase}
      selectedAddress={radioAddress}
      updateAddressErrorRes={props?.invalidAdressUnitCode}
      locusIdNotFound={locusIdNotFound}
    />
  );

  const isUpdateFormError = () => {
    if (MISSING_APARTMENT_UNIT_CODE === props?.invalidAdressUnitCode || INVALID_APARTMENT_UNIT_CODE === props?.invalidAdressUnitCode) {
      setShowForm(true);
      setIsErrorOnUpdate(true);
    } else if (
      !isAddressChangeRsnCodeValue &&
      MISSING_APARTMENT_UNIT_CODE === props?.invalidAdressUnitCode &&
      props?.updateAddressApiError[0]?.name === MISSING_APARTMENT_UNIT_NAME
    ) {
      setServiceAdressValidator(true);
    }
  };

  useEffect(() => {
    isUpdateFormError();
  }, [props.updateAddressApiError]);

  return (
    <React.Fragment>
      <Body bold>
        {(isShippingTabEnabled() ? !props.showPickupInfoTab : !ispuSelected) && (
          <div className="shippingAddressWrapper">{props.shippingAddressText ? props.shippingAddressText : 'Shipping address'}</div>
        )}
      </Body>
      {(isShippingTabEnabled() ? !props?.showPickupInfoTab : !ispuSelected) && (
        <fieldset aria-label="Shipping address" className="noPad noBorder">
          <Row>
            <AddressOptionCol>
              <RadioButtonGroup
                value={shippingRadio}
                onChange={onChangeHandler}
                error={false}
                data={shippingOptions.map((option) => ({
                  label: option,
                  id: shippingRadio,
                  children:
                    // option === sameAdress ? (
                    //   <AddressSubtext size="medium" bold>
                    //     {isLoggedIn !== true ? getFullAddress(props.cartDetails?.cart5GAddress) : getFullAddress(props?.shippingAddAAL)}
                    //   </AddressSubtext>
                    // ) : option === LQAddress ? (
                    //   <AddressSubtext size="medium" bold>
                    //     {getFullAddress(props.cart5GAddress)}
                    //   </AddressSubtext>
                    // ) : undefined,

                    option === sameAdress ? (
                      <AddressSubtext size="medium" bold>
                        {invalidUnitApartmentCase
                          ? showForm && shippingRadio === option && isErrorOnUpdate
                            ? shippingUnitForm(true, props?.shippingAddAAL)
                            : isLoggedIn !== true
                              ? getFullAddress(props.cartDetails?.cart5GAddress)
                              : getFullAddress(props?.shippingAddAAL)
                          : isLoggedIn !== true
                            ? getFullAddress(props.cartDetails?.cart5GAddress)
                            : getFullAddress(props?.shippingAddAAL)}
                      </AddressSubtext>
                    ) : option === LQAddress ? (
                      <AddressSubtext size="medium" bold>
                        {serviceAdressValidator || invalidUnitApartmentCase
                          ? showForm && shippingRadio === option
                            ? shippingUnitForm(true, props?.cart5GAddress)
                            : getFullAddress(props.cart5GAddress)
                          : getFullAddress(props.cart5GAddress)}
                      </AddressSubtext>
                    ) : undefined,

                  // option === sameAdress ? (
                  //   <AddressSubtext size="medium" bold>
                  //     {isAddressChangeRsnCode
                  //       ? showForm && shippingRadio === option
                  //         ? ''
                  //         : isLoggedIn !== true
                  //           ? getFullAddress(props.cartDetails?.cart5GAddress)
                  //           : getFullAddress(props?.shippingAddAAL)
                  //       : isLoggedIn !== true
                  //         ? getFullAddress(props.cartDetails?.cart5GAddress)
                  //         : getFullAddress(props?.shippingAddAAL)}
                  //     {isAddressChangeRsnCode && shippingRadio === option && showForm && !props.cart5GAddress.addressLine2 && isLoggedIn !== true
                  //       ? shippingUnitForm(true, props?.cartDetails?.cart5GAddress)
                  //       : showForm &&
                  //         shippingRadio === option &&
                  //         !props?.shippingAddAAL?.addressLine2 &&
                  //         shippingUnitForm(true, props?.shippingAddAAL)}
                  //   </AddressSubtext>
                  // ) : option === LQAddress ? (
                  //   <AddressSubtext size="medium" bold>
                  //     {isAddressChangeRsnCode
                  //       ? showForm && shippingRadio === option
                  //         ? ''
                  //         : getFullAddress(props.cart5GAddress)
                  //       : getFullAddress(props.cart5GAddress)}
                  //     {isAddressChangeRsnCode &&
                  //       shippingRadio === option &&
                  //       showForm &&
                  //       !props?.cart5GAddress?.addressLine2 &&
                  //       shippingUnitForm(true, props?.cart5GAddress)}
                  //   </AddressSubtext>
                  // ) : undefined,
                  value: option,
                }))}
                className="addressOptions"
              />
            </AddressOptionCol>
          </Row>
        </fieldset>
      )}
      {Object.keys(selectedSDDSlot).length !== 0 && (
        <div className="contains-PII" data-cs-mask>
          <h3>Same-day Shipping</h3>
          <div>{serviceAddress}</div>
          <Row>
            <Col xs={6}>
              {selectedSDDSlot.startTime}-{selectedSDDSlot.endTime}
            </Col>
            <Col xs={1} className="marginTop6 noRightPad">
              <Button size="large" analyticstrack="5G-editContactInfo" onClick={toggleContactInfoSDD} data-track>
                Edit
              </Button>
            </Col>
          </Row>
          <ContactInfoForm {...props} />
        </div>
      )}
      {showPickupInfo ? (
        <>
          <Row middle="xs">
            <Col xs={10} lg={5}>
              <Body primitive="p" size="large" bold>
                Pickup contact information
              </Body>
              <StyledWrapper styles={`margin-top: 4px; ${nonMobileQuery('margin-top: 8px;')}`}>
                <Body color="#6F7171" primitive="p" size="small">
                  {props?.primaryUserInfo?.firstName} {props?.primaryUserInfo?.lastName}
                </Body>
                <Body color="#6F7171" primitive="p" size="small">
                  {props.getCheckOutDetailsState?.getCheckoutResponse?.data?.cart?.lineDetails?.lineInfo?.newLine1?.shipping?.address?.emailId}
                </Body>
                <Body color="#6F7171" primitive="p" size="small">
                  {props.getCheckOutDetailsState?.getCheckoutResponse?.data?.cart?.lineDetails?.lineInfo?.newLine1?.shipping?.address?.phoneNumber}
                </Body>
              </StyledWrapper>
            </Col>
            {!isExpressCheckout() && (
              <Col xs={1}>
                <Button size="large" analyticstrack="5G-editContactInfo" onClick={toggleContactInfoISPU} data-track>
                  Edit
                </Button>
              </Col>
            )}
          </Row>
          <StyledWrapper styles="margin: 33px 0px 23px;">
            <Line type="secondary" surface="light" />
          </StyledWrapper>
          <Row>
            <Col style={{ paddingTop: '10px' }} xs={12} lg={6}>
              <Body primitive="p" size="large" bold>
                A couple of important things
              </Body>
              <StyledWrapper styles="margin-top: 8px" />
              <Body color="#6F7171" primitive="p" size="medium">
                {props?.primaryUserInfo?.firstName} {props.primaryUserInfo?.lastName} must pickup the order. Bring the government-issued ID and the
                card used to make the purchase
              </Body>
            </Col>
          </Row>
        </>
      ) : null}
      {props.showPickupInfoTab && showISPUContactForm ? (
        <ContactInfoForm {...props} />
      ) : (
        showISPUContactForm && ispuSelected && <ContactInfoForm {...props} />
      )}
      {isDesktop() ? renderElement(ispuCTA, 'ispuCTA', showISPUCTA) : ispuCTA}
      {shippingRadio === NEW_SHIPPING_ADDRESS && showSecurePinModal && (
        <SecurePin
          {...props}
          CloseModel={CloseModel}
          securePinDataDeviceSucess={props.shippingInfoState}
          devices={props.securePinDataDeviceSucess.fetchSMSEnabledDevices}
          cancelUpdated={cancelUpdated}
          modalChanged={modalChanged}
        />
      )}
      {displayNewSHPAddressForm() && !props.showPickupInfoTab && shippingUnitForm(false)}

      {isDesktopResolution() ? renderElement(shippingAddressCTA, 'shippingAddressCTA_2', showShippingAddressCTA) : shippingAddressCTA}
    </React.Fragment>
  );
};

ShippingAdress.propTypes = {
  selectedShippingOption: PropTypes.object,
  shippingAddress: PropTypes.array,
  securePinSendSms: PropTypes.func,
  securePinData: PropTypes.object,
  securePinDataDeviceSucess: PropTypes.object,
  fetchSMSEnabledDevices: PropTypes.func,
  cartDetails: PropTypes.object,
  shippingRadio: PropTypes.string,
  sddSlots: PropTypes.object,
  buildShippingOptionsInput: PropTypes.func,
  securePinValidateAuthCode: PropTypes.func,
  getSmsSuccess: PropTypes.func,
  securePinSendSMS: PropTypes.func,
  currentView: PropTypes.object,
  orderDetails: PropTypes.object,
  history: PropTypes.object,
  updateShippingAddress: PropTypes.func,
  shippingInfoDetails: PropTypes.object,
  shippingInfoState: PropTypes.object,
  getZipDetailsFromApi: PropTypes.func,
  marketDetails: PropTypes.object,
  clearDevices: PropTypes.func,
  contactInfoUpdte: PropTypes.func,
  toggleContactInfo: PropTypes.func,
  shippingAddressText: PropTypes.string,
  isCreditStatusAvailable: PropTypes.bool,
  creditStatusLanded: PropTypes.bool,
  notifyMessage: PropTypes.string,
  getPaymentOptions: PropTypes.func,
  paymentInfoState: PropTypes.any,
  isBTAAvailable: PropTypes.any,
  confirmSubmit: PropTypes.any,
  isBTAEligible: PropTypes.any,
  otherPaymentOptions: PropTypes.any,
  isbillingInfoEdited: PropTypes.bool,
  paymentZipcodeError: PropTypes.string,
  showErrorNotification: PropTypes.any,
  updateValidateOTPResponse: PropTypes.string,
  emailVaildationShippingAPI: PropTypes.func,
  accMainEmailShippingVerify: PropTypes.func,
  setEmailValidationdata: PropTypes.func,
  fetchAutoFillAddress: PropTypes.func,
  addressList: PropTypes.array,
  shippingAddressErrorMessage: PropTypes.string,
  lvShippingAddressTitle: PropTypes.string,
  lvShippingAddressSubtitle: PropTypes.string,
  isEmptyAddress: PropTypes.string,
  shipping_info_email_legal_new: PropTypes.string,
  apiFailureError: PropTypes.any,
  shippingInvalidError: PropTypes.any,
  getCheckOutDetailsState: PropTypes.any,
  devices: PropTypes.any,
  getCheckOutDetails: PropTypes.any,
  shippingAddAAL: PropTypes.any,
  defaultShippingAddAAL: PropTypes.any,
  totalDueToday: PropTypes.any,
  isPaymentNeed: PropTypes.bool,
  primaryUserInfo: PropTypes.any,
  addressChangeRequired: PropTypes.any,
  depletionType: PropTypes.any,
  apiConfigCall: PropTypes.func,
  shippingAddressEdited: PropTypes.func,
  shippingAddressEdit: PropTypes.bool,
  cart5GAddress: PropTypes.object,
  shippingAddressRadio: PropTypes.string,
  setShippingAddressRadio: PropTypes.func,
  cradleResponseDetails: PropTypes.bool,
  showPickupInfoTab: PropTypes.bool,
  smsEnabledDevices: PropTypes.array,
  smsEnabledDeviceCount: PropTypes.number,
  pinVerified: PropTypes.string,
  addressChangeRsnCode: PropTypes.string,
  fetchAutoFillAddressUnit2: PropTypes.func,
  unitlist: PropTypes.any,
  invalidAdressUnitCode: PropTypes.string,
  updateAddressApiError: PropTypes.any,
};

export default reduxForm({
  form: 'shippingFormDetails',
})(ShippingAdress);
